import two from "../../assets/images/user/2.png";
import three from "../../assets/images/user/3.jpg";
import eight from "../../assets/images/user/8.jpg";
import ten from "../../assets/images/user/10.jpg";
import fourteen from "../../assets/images/user/14.png";
import four from "../../assets/images/user/4.jpg";
import one from "../../assets/images/user/1.jpg";
import five from "../../assets/images/user/5.jpg";
import eleven from "../../assets/images/user/11.png";
import six from "../../assets/images/user/6.jpg";

import { AndewJon, SarahLoren, BuckyBarnes, ComerenDiaz, JasonBorne, JohnyWaston, JohnyWilliam } from "../../Constant";


export const AvatarsData = [
    {
        img: two,
        name: 'Jason Borne',
        btn: 'AddFriend'
    },
    {
        img: three,
        name: 'Anna Mull',
        btn: 'AddFriend'
    },
    {
        img: three,
        name: 'Dion Cast',
        btn: 'AddFriend'
    },
    {
        img: four,
        name: 'Karlene Lex',
        btn: 'AddFriend'
    },
    {
        img: eight,
        name: 'Vella Chism',
        btn: 'AddFriend'
    },
    {
        img: ten,
        name: 'Wai Schalk',
        btn: 'AddFriend'
    },
    {
        img: fourteen,
        name: 'Karlene Lex',
        btn: 'AddFriend'
    }
]

export const customersData = [
    {
        img: three,
        name: JohnyWaston
    },
    {
        img: five,
        name: AndewJon
    },
    {
        img: one,
        name: ComerenDiaz
    },
    {
        img: two,
        name: BuckyBarnes
    },
    {
        img: eight,
        name: JasonBorne
    },
    {
        img: eleven,
        name: ComerenDiaz
    }
]

export const MutualFriendsData = [
    {
        img: two,
        name: BuckyBarnes,
        email: 'winter@gmail.com',
        status: 'social-online'
    },
    {
        img: ten,
        name: SarahLoren,
        email: 'barnes@gmail.com',
        status: 'social-busy'
    },
    {
        img: six,
        name: JasonBorne,
        email: 'jasonb@gmail.com',
        status: 'social-offline'
    },
    {
        img: eight,
        name: ComerenDiaz,
        email: 'comere@gmail.com',
        status: 'social-offline'
    },
    {
        img: fourteen,
        name: AndewJon,
        email: 'andrewj@gmail.com',
        status: 'social-online'
    },
    {
        img: four,
        name: JohnyWaston,
        email: 'johny@gmail.com',
        status: 'social-busy'
    },
    {
        img: three,
        name: JohnyWilliam,
        email: 'johnyw@gmail.com',
        status: 'social-offline'
    },
    {
        img: two,
        name: BuckyBarnes,
        email: 'winter@gmail.com',
        status: 'social-online'
    },
    {
        img: ten,
        name: SarahLoren,
        email: 'barnes@gmail.com',
        status: 'social-busy'
    },
    {
        img: six,
        name: JasonBorne,
        email: 'jasonb@gmail.com',
        status: 'social-offline'
    },
    {
        img: two,
        name: BuckyBarnes,
        email: 'winter@gmail.com',
        status: 'social-online'
    },
    {
        img: ten,
        name: SarahLoren,
        email: 'barnes@gmail.com',
        status: 'social-busy'
    },
    {
        img: six,
        name: JasonBorne,
        email: 'jasonb@gmail.com',
        status: 'social-offline'
    }
]

export const ActivityFeedData = [
    {
        img: ten,
        name: AndewJon,
        para: `Commented on Shaun Park's`,
        time: '20 min Ago'
    },
    {
        img: three,
        name: JohnyWaston,
        para: `Commented on Shaun Park's`,
        time: '1 hour Ago'
    },
    {
        img: five,
        name: ComerenDiaz,
        para: `Commented on Shaun Park's`,
        time: '1 days Ago'
    },
    {
        img: four,
        name: SarahLoren,
        para: `Commented on Shaun Park's`,
        time: '2 days Ago'
    },
    {
        img: three,
        name: JohnyWaston,
        para: `Commented on Shaun Park's`,
        time: '5 days Ago'
    },
    {
        img: five,
        name: ComerenDiaz,
        para: `Commented on Shaun Park's`,
        time: '6 days Ago'
    }
]